/**
* BaseView
*/

define(function(require, exports, module) {
    'use strict';

    const BaseView = require('common/base.view');
    const _ = require('underscore');

    module.exports = BaseView.extend({
        extendEvents: function(newEvents) {
            var events = this.events;

            if (_.isFunction(events)) {
                events = events.apply(this, arguments);
            }

            events = _.extend({}, events, newEvents);

            return events;
        }
    });
});
